import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import "./App.css";

import "./LandingLayout.css";

import studentLeft from "./images/student-left-homepage.png";
import studentRight from "./images/student-right-homepage.png";

export default function LandingLayout() {
  const location = useLocation();

  const isHomePage = location.pathname === "/";

  return (
    <div className="landing-layout">
      {/* Header - FIXED so it always stays visible at top */}
      <header className="landing-header">
        <h1>
          <Link to="/" className="header-link">
            ShareMySchedule
          </Link>
        </h1>
      </header>

      {/* Floating accents (used everywhere) - now FIXED */}
      <div
        className="floating-accent star"
        style={{ width: "30px", height: "30px", top: "15%", left: "12%" }}
      ></div>
      <div
        className="floating-accent circle"
        style={{ width: "18px", height: "18px", top: "35%", right: "18%" }}
      ></div>
      <div
        className="floating-accent star"
        style={{ width: "22px", height: "22px", bottom: "25%", left: "40%" }}
      ></div>
      <div
        className="floating-accent circle"
        style={{ width: "15px", height: "15px", bottom: "15%", right: "30%" }}
      ></div>
      <div
        className="floating-accent star"
        style={{ width: "20px", height: "20px", top: "55%", left: "60%" }}
      ></div>

      <main className="landing-content">
        <Outlet />
      </main>

      {/* Illustrations only on homepage */}
      {isHomePage && (
        <>
          {/* ✅ ADD THIS FOOTER ELEMENT */}
          <footer className="landing-footer">
            {/* ✅ CHANGE THIS LINE */}
            <a
              href="https://www.linkedin.com/in/shaheerl/"
              target="_blank"
              rel="noopener noreferrer"
            >
              by Shaheer Lone
            </a>
          </footer>
          <img
            src={studentLeft}
            alt="Student illustration left"
            className="illustration left"
          />
          <img
            src={studentRight}
            alt="Student illustration right"
            className="illustration right"
          />
        </>
      )}
    </div>
  );
}
